import { GatsbyImage } from 'gatsby-plugin-image'

const GImage = props => {
  if (!props?.data?.gatsbyImageData) { return null }
  return (
    <GatsbyImage image={props?.data?.gatsbyImageData} alt={props?.data?.alt ?? ''} {...props} />
  )
}

export default GImage
